const tn = {
  tn1: { name: 'Programmieren', desc: 'z.B. Computer, Maschinen, Steuerungssystem', },
  tn2: { name: 'Untersuchen', desc: 'z.B. chemische Elemente, Nahrungsmittel, Werkstoffe', },
  tn3: { name: 'Berechnen', desc: 'z.B.  Baupläne, Leitungen', },
  tn4: { name: 'Experimentieren', desc: 'z.B. mit unbekannten Stoffen, Medikamenten', },
  tn5: { name: 'Dokumentieren und beschreiben', desc: 'z.B. physikalische Versuche, Experimente', },
  tn6: { name: 'Messen', desc: 'z.B. Abgaswerte eines Pkw, elektrische Spannung', },
  tn7: { name: 'Vergleichen', desc: 'z.B. Testergebnisse, Forschungsberichte, Diagramme', },
  tn8: { name: 'Erforschen', desc: 'z.B. Tiere, Pflanzen, Phänomene', },
  tn9: { name: 'Prüfen', desc: 'z.B. Maschinen, Anlagen, Haushaltsgeräte', },
  tn10: { name: 'Entwickeln', desc: 'z.B. Computerprogramme, Impfstoffe', },
}

export default tn



// WEBPACK FOOTER //
// ./src/store/tn.js